import { BodyM, Heading3 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import * as Yup from 'yup'

import Icon from '@/components/Icon'
import { cityButton, cityWrapper } from '@/containers/SuggestedProperties/Onboarding/Wizard/steps/styles.css'
import { CateCity, useCities } from '@/context/Cities'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { suggestedOnboardingPath } from '@/i18n-routes'
import { countryFiltersByLocale } from '@/utils/locale-variables'
import { buildRelativeLocalizedLink } from '@/utils/navigation'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleClick, handleShow } from '@/utils/tracking/eventsHandlers'

import { citySelectionWrapper } from '../../../Feed/style.css'

export const citySelectionInitialValue = () => ({ city: '' })
export const citySelectionValidation = () =>
  Yup.object().shape({
    city: Yup.string().required(),
  })

export const CitySelection: React.FC = () => {
  const cities = useCities().list.filter((city) => city.slug === city.referenceArea)
  const { lang, t } = useTranslation()
  const router = useRouter()

  const {
    publicRuntimeConfig: { casavoUiCdn },
  } = getConfig()

  useEffect(() => {
    handleShow(GTMEventCategory.MainSearchFlow, 'FirstStep')
  }, [])

  const handleCityButtonClick = (city: CateCity) => {
    const cityName = city.slug.split('/')[1]
    router.push(`${buildRelativeLocalizedLink(suggestedOnboardingPath, lang)}${cityName}`)
    handleClick(GTMEventCategory.MainSearchFlow, 'SelectCity_next')
  }

  return (
    <div className={citySelectionWrapper}>
      <Heading3 className={sprinkles({ paddingBottom: 'xl' })}>{t('suggested:City_Question')}</Heading3>
      <div className={cityWrapper} role="list">
        {cities.map((city, index) => (
          <button key={index} className={cityButton} onClick={() => handleCityButtonClick(city)}>
            <div
              className={sprinkles({
                alignItems: 'center',
                display: 'flex',
                gap: 'm',
                justifyContent: 'center',
              })}
            >
              <img
                alt="city icon"
                height="35"
                src={`${casavoUiCdn}/illustrations/cities/${
                  countryFiltersByLocale[lang]
                }/${city.name.toLowerCase()}-small.svg`}
                width="35"
              ></img>

              <BodyM className={sprinkles({ flex: 1 })}>{city.translatedCityName}</BodyM>
            </div>
            <Icon.Chevron />
          </button>
        ))}
      </div>
    </div>
  )
}
